import $ from 'jquery';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import debounce from 'lodash.debounce';
import * as modal from '../components/modal';

let offices = null;

class Map {
	/**
	 * When creating a map, it takes data from localStorage api response and parses it into this.data variable,
	 * from which other class attributes will take needed data.
	 * this.mapElement is a map object for interacting with google map
	 * this.defaultBounds are just bounds that the default map view will be in (also from api)
	 * this.markercon is a reference icon for most markers (also from api)
	 * this.locations is an array of given locations (also from api - f.e Brno)
	 * this.markers is an array for all markers made from this.locations array
	 * this.activeMarker is just currently highlighted marker
	 * this.cluster is a cluster for all markers inside this.markers
	 * this.referenceLocationMarker is a special marker, that only holds either
	 * 		a current device location's marker or marker of chosen google search place's location
	 */
	constructor() {
		//this.data = JSON.parse(localStorage.getItem("ApiResponse"));
		const boundsArray = [
			{
				lat: 51.03742751,
				lng: 12.11884927,
			},
			{
				lat: 48.59998381,
				lng: 18.89656778,
			},
		];
		this.data = offices;
		this.mapElement = new google.maps.Map(document.getElementById('map'), {
			mapId: 'bda3871f628bee0a',
			disableDefaultUI: true,
		});
		this.defaultBounds = new google.maps.LatLngBounds();
		offices.forEach((bound) => {
			const boundLat = parseFloat(bound.Address.GpsLatitude);
			const boundLng = parseFloat(bound.Address.GpsLongitude);
			const testLat = isNaN(boundLat);
			if (testLat === false) {
				this.defaultBounds.extend(new google.maps.LatLng(boundLat, boundLng));
			}
		});
		//this.markerIcon = this.data.icon;
		this.locations = this.data;

		this.markers = [];
		this.activeMarker = null;
		this.cluster = null;

		this.referenceLocationMarker = null;
	}

	/**
	 * Generates side panel items based on current map view (markers).
	 * First, it takes markers, that are currently visible on the map.
	 * Then it maps this array of markers into source location array
	 * (markers dont have locations' info like name, opening hours, etc)
	 * Finally, it generates the items by injecting html with output array of locations.
	 */
	updateLocationsList() {
		let bounds = this.mapElement.getBounds();
		let visibleMarkers = this.markers.filter((marker) => bounds.contains(marker.getPosition()));

		let locationsList = visibleMarkers.map((marker) => {
			return this.locations.find((location) => marker.id == location.Id);
		});

		let dist;
		locationsList.map((item) => {
			const lat = parseFloat(item.Address.GpsLatitude);
			const lng = parseFloat(item.Address.GpsLongitude);
			let latlng = new google.maps.LatLng(lat, lng);
			item.dist = (this.getDistance(latlng, this.referenceLocationMarker.getPosition()) / 1000).toFixed(2);
		});
		let locationsListSort = locationsList.sort(function (a, b) {
			return a.dist - b.dist;
		});
		let records = locationsListSort.map((location) => {
			return (
				`
			<div class="map-locations__item js-map-focus" data-map-focus="` +
				location.Id +
				`">
				<span class="js-icon-svg icon-svg icon-svg--marker-red" aria-hidden="true">
					<svg class="icon-svg__svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						<use xlink:href="../img/bg/icons-svg.svg#icon-marker-red" width="100%" height="100%" focusable="false"></use>
					</svg>
				</span>
				<div class="map-locations__info">
					<span class="map-locations__name">` +
				location.Address.City +
				`</span>
					<span class="map-locations__distance">
						` +
				location.dist +
				` km
					</span>
				</div>
				<span class="js-icon-svg icon-svg icon-svg--arrow-right map-locations__icon--right" aria-hidden="true">
					<svg class="icon-svg__svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						<use xlink:href="../img/bg/icons-svg.svg#icon-arrow-right" width="100%" height="100%" focusable="false"></use>
					</svg>
				</span>
			</div>`
			);
		});
		$('.js-map-locations-list').html(records);
	}

	/**
	 * Changes svg path and fillColor of given marker.
	 * Given marker will be assigned to this.activeMarker for future usage
	 * Is usually called from focusOnMarker function
	 * @param {google.maps.Marker} marker
	 */
	activateMarker(marker) {
		//marker.icon.path = marker.icon.activeSvg;
		//marker.icon.fillColor = marker.icon.activeColor;
		marker.icon.url = '../img/illust/marker-white.svg';
		//marker.icon.anchor = new google.maps.Point(9, 26);
		//marker.icon.size = new google.maps.Size(39, 56),

		marker.setIcon(marker.icon);
		this.activeMarker = marker;
	}

	/**
	 * Resets the design of currently active marker (this.activeMarker)
	 */
	resetActiveMarker() {
		if (this.activeMarker !== null) {
			this.activeMarker.icon.url = '../img/illust/marker-red.svg';

			//this.activeMarker.icon.path = this.activeMarker.icon.defaultSvg;
			//this.activeMarker.icon.fillColor = this.activeMarker.icon.defaultColor;
			this.activeMarker.setIcon(this.activeMarker.icon);
		}
	}

	/**
	 * Makes the map fit into pre-given default bounds
	 */
	fitToDefaultBounds() {
		this.mapElement.fitBounds(this.defaultBounds);
	}

	/**
	 * Generates information about given location (when clicked on marker or from sidebar list)
	 * It looks for the correct location in this.locations array.
	 *
	 * @param {*} id -- ID of location (or coresponding marker)
	 */
	////////////// TODO  //////////////
	updateActiveInfo(id) {
		const target = this.locations.find((location) => location.Id === id);
		let records = '';
		let streetNumber = target.Address.HouseNum1;
		if (target.Address.HouseNum2) {
			streetNumber += '/' + target.Address.HouseNum2;
		}
		const address = target.Address.Street + '&nbsp;' + streetNumber + ', ' + target.Address.City + ', ' + target.Address.PostCode;
		let opening = '';
		let phone = target.Phone;
		if (phone.replace(/ /g, '').length == 9) {
			phone = '+420 ' + phone;
		}
		let addressUrl = target.Address.Street + ' ' + target.Address.HouseNum1 + ',' + target.Address.City;
		addressUrl = encodeURI(addressUrl);
		let neco = target.Address.GpsLatitude + `,` + target.Address.GpsLongitude;
		target.Opening.forEach((item) => {
			opening +=
				'<span class="map-sidebar__opening"><span class="map-sidebar__day">' +
				item.Name +
				'</span><span class="map-sidebar__hourse">' +
				item.Hours +
				'</span></span>';
		});
		records +=
			`
		<div class="map-sidebar__record">
			<span class="map-sidebar__title">Adresa</span>
			<span class="map-sidebar__value">` +
			address +
			`</span>
		</div>
		`;

		let multipleButtons =
			`<div class="map-sidebar__btn-group">
			<p>
				<a target="_blank" rel="noopener" href="https://www.google.com/maps/dir/?api=1&destination=` +
			addressUrl +
			`" class="btn">
					<span class="btn__text">Navigovat</span>
				</a>
			</p>`;
		if (target.Address.City == 'Brno') {
			multipleButtons += `<p>
			<a  href="#" class="btn js-modal-open" data-modal-type="html" data-modal-target="/schuzka/120">
			<span class="btn__text">Sjednat osobní schůzku</span>
			</a>
		</p>
		</div>
		`;
			records += multipleButtons;
		} else if (target.Address.City == 'České Budějovice') {
			multipleButtons += `<p>
			<a  href="#" class="btn js-modal-open" data-modal-type="html" data-modal-target="/schuzka/124">
				<span class="btn__text">Sjednat osobní schůzku</span>
			</a>
		</p>
		</div>
		`;
			records += multipleButtons;
		} else {
			records +=
				`
		<p>
			<a target="_blank" rel="noopener" href="https://www.google.com/maps/dir/?api=1&destination=` +
				addressUrl +
				`" class="btn">
				<span class="btn__text">Navigovat</span>
			</a>
		</p>
		`;
		}

		if (target.Message) {
			records +=
				`
			<span class="map-sidebar__message">
			<span class="js-icon-svg icon-svg icon-svg--alert" aria-hidden="true">
			<svg class="icon-svg__svg" xmlns:xlink="http://www.w3.org/1999/xlink">
				<use xlink:href="../img/bg/icons-svg.svg#icon-alert" width="100%" height="100%" focusable="false"></use>
			</svg>
		</span>` +
				target.Message +
				`</span>
			`;
		}
		records +=
			`
		<div class="map-sidebar__record">
			<span class="map-sidebar__title">Otevírací doba</span>
			<span class="map-sidebar__value">` +
			opening +
			`</span>
		</div>
		<div class="map-sidebar__record">
			<span class="map-sidebar__title">Kontakty</span>
			<span class="map-sidebar__value">` +
			target.FirstName +
			` ` +
			target.SurName +
			`<br />` +
			phone +
			`<br /><a href="mailto:` +
			target.Email +
			`">` +
			target.Email +
			`</a></span>
		</div>

		`;

		$('.js-map-location-content').html(
			`
			<h3 class="map-sidebar__header h4">` +
				target.Address.City +
				`</h3>
			<div class="map-sidebar__content">
				` +
				records +
				`
			</div>
			`,
		);
		modal.init($(document));
	}

	/**
	 * Makes the map focus onto given marker by zooming and panning onto it.
	 * First, it resets the current marker (this.activeMarker) to it's default state,
	 * then it activates the given one.
	 * This function also triggers the sidebar switch and calls the updateActiveInfo function
	 * to make sure that the currently clicked location information will be displayed.
	 *
	 * @param {google.maps.Marker} marker
	 */

	focusOnMarker(marker) {
		this.resetActiveMarker();
		this.activateMarker(marker);

		this.mapElement.setZoom(14);
		this.mapElement.panTo(marker.getPosition());

		$.when($('.js-map-sidebar-locations').fadeOut(100)).then(() => {
			this.updateActiveInfo(marker.id);
			$('.js-map-sidebar-active').fadeIn(100);
		});
	}

	/**
	 * Returns the distance between two places via straight line
	 *
	 * @param {google.maps.LatLng} from
	 * @param {google.maps.LatLng} to
	 */
	getDistance(from, to) {
		return google.maps.geometry.spherical.computeDistanceBetween(from, to);
	}

	/**
	 * Returns the nearest marker from given location
	 * This search is based on this.markers variable (all markers)
	 *
	 * @param {number} lat
	 * @param {number} lng
	 */
	findNearestMarker(lat, lng) {
		let source = new google.maps.LatLng(lat, lng);
		let nearest = this.markers.reduce((previous, current) => {
			let cpos = this.getDistance(source, current.position);
			let ppos = this.getDistance(source, previous.position);
			return cpos < ppos ? current : previous;
		});
		return nearest;
	}

	/**
	 * This function creates special marker. This marker represents either device's location
	 * or location of place from searchbar (Its the black circle).
	 * Is assigned to variable this.referenceLocationMarker.
	 */
	createReferenceMarker() {
		this.referenceLocationMarker = new google.maps.Marker({
			icon: {
				path: ` M8.9 0C4 0 0 3.9 0 8.7c0 4.7 4.3 11.4 8.2 16 .2.2.4.4.7.4.3 0 .5-.2.7-.4 3.8-4.5 8.2-11.3 8.2-16C17.8 4 14 .1 9.2 0h-.3zm0 13.9c-3.1 0-5.5-2.4-5.5-5.4s2.4-5.4 5.5-5.4 5.5 2.4 5.5 5.4-2.5 5.4-5.5 5.4z`,
				fillOpacity: 1,
				fillColor: '#ea1b0a',
				strokeOpacity: 0,
				anchor: new google.maps.Point(17, 17),
				scale: 1.6,
			},
			zIndex: 100,
		});
	}

	/**
	 * Finds the nearest marker from the given location (refLocation), generates/moves special marker to this location
	 * and moves the map so that both the given location and the special marker are visible
	 * The specieal marker is this.referenceLocationMarker, which can hold current location of device or
	 * location of place from sidebar search.
	 *
	 * @param {google.maps.LatLng} refLocation
	 */

	focusReferenceAndNearest(refLocation) {
		let nearestMarker = this.findNearestMarker(refLocation.lat, refLocation.lng);

		if (this.referenceLocationMarker === null) {
			this.createReferenceMarker();
			this.referenceLocationMarker.setMap(this.mapElement);
		}

		this.referenceLocationMarker.setPosition(refLocation);

		let bounds = new google.maps.LatLngBounds();
		bounds.extend(this.referenceLocationMarker.getPosition());
		bounds.extend(nearestMarker.getPosition());

		this.mapElement.fitBounds(bounds);

		this.updateLocationsList();
		this.resetActiveMarker();
	}

	/**
	 * Initializer for all markers based on received data (this.locations).
	 * The result is saved to this.markers.
	 */
	initMarkers() {
		this.locations.forEach((location) => {
			const lat = parseFloat(location.Address.GpsLatitude);
			const lng = parseFloat(location.Address.GpsLongitude);
			const latTest = isNaN(lat);
			if (latTest === false) {
				let marker = new google.maps.Marker({
					id: location.Id,
					position: {
						lat: lat,
						lng: lng,
					},
					icon: {
						url: '../img/illust/marker-red.svg',
						anchor: new google.maps.Point(0, 26),
						size: new google.maps.Size(39, 56),
					},
					title: 'location.Id',
					/* 				icon: {
						path: this.markerIcon.defaultSvg,
						defaultSvg: this.markerIcon.defaultSvg,
						activeSvg: this.markerIcon.activeSvg,
						defaultColor: this.markerIcon.defaultColor,
						activeColor: this.markerIcon.activeColor,
						fillOpacity: 1,
						fillColor: this.markerIcon.defaultColor,
						strokeOpacity: 0,
						scale: 1.5,
						anchor: new google.maps.Point(9, 26)
					} */
				});
				marker.addListener('click', () => {
					this.focusOnMarker(marker);
				});
				this.markers.push(marker);
			}
		});
	}

	/**
	 * Creates a cluster with all markers from this.markers array
	 * (this.cluster)
	 */
	initCluster() {
		this.cluster = new MarkerClusterer(this.mapElement, this.markers, {
			styles: [
				{
					textColor: 'black',
					className: 'map__cluster',
					width: 45,
					height: 45,
				},
			],
		});
	}

	/**
	 * This function sets up a toggles from outside of the map, that somehow manipulate the map.
	 * 1) every place generated in sidebar acts like a button for activating certain marker (by id)
	 * 2) activated location (in sidebar) with detailed information has a close button
	 * 3) input field (the search box) has a cross button that deletes the current search value and defaults the map view
	 */
	initOutsideToggles() {
		const self = this;

		$(document).on('click', '.js-map-focus', function (event) {
			event.preventDefault();
			const targetMarkerId = $(this).data('map-focus');
			const foundTarget = self.markers.find((marker) => marker.id === targetMarkerId);
			self.focusOnMarker(foundTarget);
		});

		$('.js-map-sidebar-active-hide').on('click', function () {
			$.when($('.js-map-sidebar-active').fadeOut(100)).then(() => {
				$('.js-map-sidebar-locations').fadeIn(100);
				self.resetActiveMarker();
				self.mapElement.setZoom(self.mapElement.getZoom() - 1);
			});
		});
		$('.js-map-search-clear').on('click', () => {
			self.resetActiveMarker();
			self.fitToDefaultBounds();
			$('.js-map-locations-list').empty();
			$('.js-map-control-search').val('');
			$('.js-map-search-clear').removeClass('is-active');
			$('.js-map-search-clear').addClass('is-hidden');
		});
	}

	/**
	 * There are custom controls in this map. This function initializes them.
	 * 1) Zoom in button
	 * 2) Zoom out button
	 * 3) Geolocate button
	 * 4) Search box
	 * 		(not completed yet) There is a searchbox place_changed listener, which should
	 * 		take the chosen place from google dropdown, extract the location, and call focusReferenceAndNearest(location).
	 *
	 */
	initCustomControls() {
		const customControls = $('.js-map-control');

		const zoomIn = $('.js-map-control-zoom-in');
		const zoomOut = $('.js-map-control-zoom-out');
		const geolocate = $('.js-map-control-geolocate');
		const searchInput = $('.js-map-control-search');

		const self = this;

		zoomIn.on('click', () => {
			self.mapElement.setZoom(self.mapElement.getZoom() + 1);
		});
		zoomOut.on('click', () => {
			self.mapElement.setZoom(self.mapElement.getZoom() - 1);
		});
		geolocate.on('click', () => {
			if (navigator.geolocation) {
				$('.js-map-control-search').val('');
				navigator.geolocation.getCurrentPosition((position) => {
					const lat = parseFloat(position.coords.latitude);
					const lng = parseFloat(position.coords.longitude);
					let currentLocation = new google.maps.LatLng(lat, lng);

					self.focusReferenceAndNearest(currentLocation);
				});
			}
		});
		searchInput.on(
			'keydown',
			debounce(function () {
				if (searchInput.val() !== '') {
					$('.js-map-search-clear').removeClass('is-hidden');
					$('.js-map-search-clear').addClass('is-active');
				} else {
					$('.js-map-search-clear').addClass('is-hidden');
					$('.js-map-search-clear').removeClass('is-active');
				}
			}, 300),
		);

		//////////// TODO /////////////
		const placesOptions = {
			fields: ['address_components', 'geometry', 'icon'],
			componentRestrictions: { country: 'cz' },
		};
		const searchBox = new google.maps.places.Autocomplete(searchInput[0], placesOptions);
		searchBox.addListener('place_changed', () => {
			const place = searchBox.getPlace();
			this.focusReferenceAndNearest(place.geometry.location);
		});
		//////////////////////////////

		self.mapElement.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(customControls[0]);
		self.mapElement.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(customControls[1]);

		setTimeout(() => customControls.fadeIn(), 500);
	}

	selectOffice(officeId) {
		const marker = this.getOfficeMarkerById(officeId);
		setTimeout(() => google.maps.event.trigger(marker, 'click'), 500);
	}

	getOfficeMarkerById(id) {
		const foundMarkers = this.markers.filter((marker) => marker.id == id);
		return foundMarkers[0];
	}
}

function initDocumentHeadScripts(apiKey) {
	const url = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places,geometry&map_ids=bda3871f628bee0a&callback=initMap`;
	const $script = $(`script[src="${url}"]`);

	if (!$script.length) {
		let script = document.createElement('script');
		script.src = url;
		script.defer = true;
		document.head.appendChild(script);
		return script;
	}

	return $script.get();
}

export const init = async () => {
	let mapElementSource = $('#map');
	if (!mapElementSource.length) {
		return;
	}

	// const apiKey = 'AIzaSyC7uce-ttMSmXCl-yzh81wsiYFszz08Dos';
	// const apiKey = 'AIzaSyBpurYWaHie5Dg0RRi8qEWraNDBWFZ-JRE';

	const OFFICE_ID_KEY = 'officeId';

	const urlApi = mapElementSource.data('contact-url'),
		apiKey = mapElementSource.data('api-key'),
		urlSearchParams = new URLSearchParams(window.location.search);

	let map;

	try {
		const response = await $.ajax({
			url: urlApi,
		});

		offices = response.Contact;
		attachMapCallbacks(apiKey);
	} catch (err) {
		console.error('ajax error', err);
		return;
	}

	function attachMapCallbacks(apiKey) {
		// callback for "Show Map" button
		$('.js-map-init').on('click', () => initDocumentHeadScripts(apiKey));

		window.initMap = function () {
			$('.js-map-geolocation').fadeIn();
			map = new Map();
			map.initCustomControls();
			map.initOutsideToggles();

			map.fitToDefaultBounds();

			map.initMarkers();
			map.initCluster();
		};

		// use Office ID for office selection if present in query string
		if (urlSearchParams.has(OFFICE_ID_KEY)) {
			const script = initDocumentHeadScripts(apiKey),
				officeId = urlSearchParams.get(OFFICE_ID_KEY);
			script.addEventListener('load', () => map.selectOffice(officeId));
		}
	}
};
